import { createContext, useContext } from "react";

export const BillingContext = createContext({
  info: null,
  tier: "starter",
  isPremium: false,
  refresh: () => {},
});

export const useBilling = () => useContext(BillingContext);
